// Reserved for minimal logic that triggers "above the fold"

function setGlobalVariables() {
  window.config = window.config || {}

  document.documentElement.style.setProperty('--initial-height', `${window.innerHeight}px`)

  window.addEventListener('resize', updateGlobalVariables)
  updateGlobalVariables()
}

function updateGlobalVariables() {
  // Used for things like popups, drawers, etc. that need to be constrained within the viewable portion of a scroll-locked window
  document.documentElement.style.setProperty('--inner-height', `${window.innerHeight}px`)
}

// NOTE: this file used to also measure `.section-header` / `.section-announcement-bar`
// into `--nav-height` / `--bar-height`. It was removed, not moved: `setHeight` wrote
// `0px` whenever its selector matched nothing, as an inline style on the same
// documentElement the `set-height-as-css-var` utility writes to, re-applied on every resize.
// A store whose header does not carry those exact class names — or, as here, one whose
// header splits into two sections where the hidden one measures 0 — got its height
// tokens silently zeroed and then re-zeroed on resize. Both properties are now
// published by `data-utility="set-height-as-css-var"` on the element that actually owns
// the height, with static fallbacks in dev/css/base/reset.css for the pre-JS frame.
setGlobalVariables()
